/**
 * ホスティングのページ（親フレーム）の CMP の結果（postMessage の kumo:consent）を受け取る。
 *
 * WHY ads.ts から分けたか（2026-09-27 sdk-light）: 広告の本体（ads.ts）は使うときだけ読む（/sdk/ads-<hash>.mjs）。
 * ところが親のページは同意の結果をゲームの起動直後に 1 回送ってくるだけなので、本体を読む前に聞き始めないと取りこぼす。
 * この小さい部分だけを核（/sdk.js）に残し、本体（createAds）と遅延読み込みの窓口（lazyCommerce.ts）の両方から使う。
 */

import type { ConsentInput } from './ads.js';

export function listenParentConsent(onConsent: (c: ConsentInput) => void): void {
  // 親以外からのメッセージは無視する（同じページに埋め込まれた他の iframe が「同意した」と偽れないように）
  const g = globalThis as { window?: Window & typeof globalThis };
  if (!g.window || !g.window.parent || g.window.parent === g.window || typeof g.window.addEventListener !== 'function') return;
  g.window.addEventListener('message', (ev: MessageEvent) => {
    if (ev.source !== g.window!.parent) return;
    const d = ev.data as { type?: string; personalized?: unknown; tcString?: unknown; gppString?: unknown } | null;
    if (d?.type !== 'kumo:consent' || typeof d.personalized !== 'boolean') return;
    onConsent({
      personalized: d.personalized,
      tcString: typeof d.tcString === 'string' ? d.tcString : undefined,
      gppString: typeof d.gppString === 'string' ? d.gppString : undefined
    });
  });
}
